import { useQuery } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';

export interface DashboardStats {
  empresas_total: number;
  empresas_por_funil: Record<string, number>;
  empresas_por_temperatura: Record<string, number>;
  tarefas_pendentes: number;
  tarefas_sla_estourado: number;
  tarefas_hoje: number;
  oportunidades_total: number;
  oportunidades_em_negociacao: number;
  pipeline_valor_estimado: number;
  eventos_30d: number;
  cadencias_ativas: number;
  enrich_progress?: {
    total: number;
    enriquecidas: number;
    pendentes: number;
    sem_cnpj: number;
    falhas: number;
  };
  score_distribution?: Record<string, number>;
  sinais?: {
    com_telefone: number;
    com_site: number;
    com_redes: number;
    ativa: number;
    enriquecidas: number;
  };
  top_cnaes?: Array<{ cnae: string; desc?: string; c: number }>;
  top_bairros?: Array<{ bairro: string; c: number }>;
  top_cidades?: Array<{ cidade: string; c: number }>;
  portes?: Record<string, number>;
}

export function useDashboard() {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: async () => {
      const res = await n8nFetch<{ stats: DashboardStats }>('/dashboard');
      return res.stats;
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
